import { Directive } from '@angular/core';
import { QuoteFacade } from '../+state/quote.facade';

@Directive()
export abstract class QuoteBaseComponent extends QuoteFacade {
  public text = 'Quote';

  constructor() {
    super();
  }
}
